const SELECTORS = {
  item: "[data-accordion-item]",
  toggle: "[data-accordion-toggle]"
};

const toggleAccordionItem = $item => {
  const $toggle = $item.querySelector(SELECTORS.toggle);
  if (!$toggle) return;

  const { accordionCollapsedClass } = $item.dataset;
  if (!accordionCollapsedClass) return;

  const isCollapsed = $item.classList.toggle(accordionCollapsedClass);
  $toggle.setAttribute("aria-expanded", String(!isCollapsed));
};

const initAccordion = $container => {
  if (!$container) return;
  $container.querySelectorAll(SELECTORS.item).forEach($item => {
    const $toggle = $item.querySelector(SELECTORS.toggle);
    if (!$toggle) return;

    $toggle.addEventListener("click", () => toggleAccordionItem($item));
  });
};

export default initAccordion;
